export const permissions = {
  defaultRedirectUrl: '/',
  defaultPermPrefix: 'gtcx_maps',
  routes: [['/', 'read:assets']]
};
export const appName = 'maps-frontend';

export const appVersion = '2.2.2';
export const pathDatePickerTimeLimit = 180; // days back from today
